import type { TelemetryAggregatesParams } from "@/lib/api/endpoints/telemetry";
import { getTelemetryAggregates } from "@/lib/api/endpoints/telemetry";

export type TelemetryAggregatesQueryKeyParams = TelemetryAggregatesParams & {
  metricsKey: string;
};

export const telemetryQueryKeys = {
  all: ["telemetry"] as const,
  aggregates: (p: TelemetryAggregatesQueryKeyParams) =>
    [
      ...telemetryQueryKeys.all,
      "aggregates",
      p.deviceId,
      p.metricsKey,
      typeof p.start === "string" ? p.start : p.start.toISOString(),
      typeof p.end === "string" ? p.end : p.end.toISOString(),
      p.bucketSeconds ?? 300,
      p.maxPoints ?? 8192,
      p.moduleKey ?? "explorer",
    ] as const,
};

export const telemetryGateway = {
  fetchAggregates: (params: TelemetryAggregatesParams) => getTelemetryAggregates(params),
};
